<footer class="footer mt-auto navbar w-full">
  <div class="surface-card px-4 md:px-6 xl:px-8 flex align-items-center justify-content-between w-full">
    <p>© {{currentYear}} S2 Emulator. All rights reserved</p>
    <p>Version {{ (version$ | async) || "undefined" }}</p>
  </div>
</footer>
